import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config/api-urls';
import {
  FamilyApprovalType,
  MultipleFamilyApprovalType,
  MultipleHouseHoldType,
  PersonMultipleHouseHoldData,
} from 'type/twoFactor';
import { versions } from './versions';
import { getApiClient } from './api-client';

export const familyApprovalApi = () => {
  const baseURL = `${getEnvironmentApiUrls().recap}/${versions.v2}`;

  const api = getApiClient(baseURL);

  const sendFamilyApproval = async (payload: FamilyApprovalType, signal?: AbortSignal) =>
    api.post<FamilyApprovalType>(
      `/family-approval/${payload.householdId}/person/${payload.customerPersonId}/family-approval`,
      {
        approvalDuration: payload.duration.value,
      },
      { signal },
    );

  const sendMultipleFamilyApproval = async (
    payload: MultipleFamilyApprovalType,
    signal?: AbortSignal,
  ) =>
    api.post<FamilyApprovalType>(
      `/family-approval/household/${payload.householdId}/client/${payload.customerPersonId}/multiple-approval`,
      { data: payload.data },
      { signal },
    );

  const getMultipleHouseholdPerPerson = async (payload: MultipleHouseHoldType) =>
    api.get<PersonMultipleHouseHoldData[]>(
      `/family-approval/household/${payload.householdId}/client/${payload.customerPersonId}/multiple-households`,
    );

  return {
    sendFamilyApproval,
    getMultipleHouseholdPerPerson,
    sendMultipleFamilyApproval,
  };
};
